// @ts-ignore
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const QuestionnaireConditionIsGreaterThanFragmentDoc = gql`
    fragment questionnaireConditionIsGreaterThan on QuestionnaireConditionIsGreaterThan {
  __typename
  question {
    id
  }
  value
}
    `;